const oliveA = {
  oliveA1: "hsla(0, 0%, 0%, 0)",
  oliveA2: "hsla(91, 97.0%, 84.0%, 0.026)",
  oliveA3: "hsla(101, 87.4%, 87.7%, 0.057)",
  oliveA4: "hsla(92, 91.8%, 94.1%, 0.078)",
  oliveA5: "hsla(101, 92.6%, 93.5%, 0.104)",
  oliveA6: "hsla(102, 91.1%, 94.6%, 0.130)",
  oliveA7: "hsla(102, 92.5%, 95.9%, 0.173)",
  oliveA8: "hsla(107, 100%, 96.5%, 0.250)",
  oliveA9: "hsla(110, 98.3%, 94.1%, 0.397)",
  oliveA10: "hsla(109, 99.6%, 95.3%, 0.457)",
  oliveA11: "hsla(113, 95.3%, 97.2%, 0.600)",
  oliveA12: "hsla(120, 93.5%, 99.6%, 0.927)"
};
export { oliveA };
//# sourceMappingURL=oliveA.mjs.map
